import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IDistrict } from '@core/interfaces/ilookup';
import { IUser } from '@core/interfaces/iuser';
import { AuthService } from '@core/services/auth.service';
import { LookupService } from '@core/services/lookup.service';
import { tap } from 'rxjs';

@Component({
  selector: 'prism-select-organization',
  templateUrl: './select-organization.component.html',
  styleUrl: './select-organization.component.scss'
})
export class SelectOrganizationComponent implements OnInit{
  @Output() organization = new EventEmitter<Event>();
  @Input() selectedOrganization?: number | number[] | null;
  @Input() control!: FormControl | any;
  @Input() label: string = '';
  @Input() required: boolean = false;
  @Input() readOnly?: boolean = false;
  @Input() labelClass: string = '';
  @Input() multiSelect: boolean = false;
  options: IDistrict[] = [];
  
  private authService = inject(AuthService);

  user: IUser = this.authService.getCurrentUser();

  constructor(private lookupService: LookupService) {}

  ngOnInit(): void {
    this.getOrganizations();
  }

  getOrganizations(): void {
    this.lookupService.getOrganizations()
    .pipe(
      tap((res: IDistrict[]) => {
        this.options = res.map((x: IDistrict) => ({ name: x.districtCountyName || x.name, id: x.id }))
      })
    )
    .subscribe();
  }

  emitOrganization(organization: any): void {
    this.organization.emit(organization);
  }
}
